import { Validator } from '@vista-digital/validator';
export var MemberFormGenderFieldType;
(function (MemberFormGenderFieldType) {
    MemberFormGenderFieldType["RadioGroup"] = "RadioGroup";
    MemberFormGenderFieldType["Dropdown"] = "Dropdown";
})(MemberFormGenderFieldType || (MemberFormGenderFieldType = {}));
export const memberFormGenderFieldTypeValidator = Validator.oneOf(Object.values(MemberFormGenderFieldType));
export const defaultMemberFormGenderFieldConfig = {
    type: MemberFormGenderFieldType.RadioGroup
};
export const memberFormGenderFieldConfigValidator = Validator.object({
    type: memberFormGenderFieldTypeValidator
});
